<style lang="scss" scoped>
.saTemp-detail .ivu-select-disabled {
  .ivu-tag-checked {
    cursor: default;
    border: none;
    background-color: transparent;
  }
  .ivu-icon-ios-close-empty {
    display: none;
  }
}
.saTemp-detail .ivu-form-item {
  margin-bottom: 12px;
}
</style>

<template>
    <div class="bg-fff lookinfo saTemp-detail" style="max-height:500px;overflow:auto;">
        <Form :label-width="120">
            <FormItem :label="$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})">
                <span>{{formData.stockVirtualGroupRuleEntity.name}}</span>
            </FormItem>
            <FormItem :label="$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'})">
                <span>{{formData.templateName}}</span>
            </FormItem>
            <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                <span>{{getLineName(formData.lineId)}}</span>
            </FormItem>
             <FormItem label='ERPSKU'>
                <span>{{formData.erpSku}}</span>
            </FormItem>
            <FormItem :label="$t('erp.virtualstore.description',{defaultValue:'模板描述'})">
                <span>{{formData.description}}</span>
            </FormItem>
            <!-- <FormItem label='启用DMS计算：'>
                <span>{{formData.isDms?'启用':'未启用'}}</span>
            </FormItem> -->
        </Form>
        <Table
        class="margin-15"
        :columns="columns" 
        :data="formAllot"
        size="small" 
        ref="table"  
        border
        stripe>
        <!-- <footer slot="footer" class="clearfix">
            <span style="width:330px;" class="pull-left padding-left-20">总计</span>
            <span class="pull-left">{{assignPercentTotal}}</span>
        </footer> -->
        </Table>
        <Table
            class="margin-15"
            :columns="logcolumns"  
            :data="formList"
            size="small" 
            ref="table" 
            :loading="tableloading"
            border 
            stripe>
        </Table>
        <compSpage
        class="text-right margin-top-10 margin-right-15"
        v-bind="{total,pageSize:LogformData.rows,current:LogformData.page}" 
        @on-update="getLogdetail"></compSpage>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
        
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { HttpVsGroups } from '@/service/boss/dictionary'
import { HttpSaTemplate, HttpSysOpLog} from '@/service/boss/allot';
import compSpage from '@/components/boss/spage';
export default {
    components: {
        compSpage,
	},
    props: ['id'],
    data() {
        return {
            loading: false,
            formAllot: [],
            vsrulelist: [],
            formData: {
                stockVirtualGroupRuleEntity:{name:''}
            },
            LogformData: {
				page: 1,
				rows: 10,
				sidx: 'id',
                sord: 'desc',
                "search[EQ_opModel]":'StockTemplate',
                "search[EQ_opDataId]":this.id,
            },
            formList:[],
            total:0,
            tableloading:false,
        }
    },
    created() {
        this.getDetail();
    },

    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('diction',['getNewDifferentAllProductList']),
        columns() {
            return [{
                title: this.$t('global.common.channel',{defaultValue:'店铺'}),
                key: 'accountFlag',
                width: 300,
            }, {
                title: this.$t('erp.virtualstore.assignPercent',{defaultValue:'分配比例'}),
                key: 'assignPercent',

            }, {
                title: this.$t('erp.virtualstore.adjustValue',{defaultValue:'调整值'}),
                key: 'adjustValue',

            }, {
                title: this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'}),
                key: 'safeQuantity',
            }]
        },
        logcolumns(){
            return [{
                title: this.$t('fbb.alloment.date',{defaultValue:'日期'}),
                key: 'updatedAt',
                render(h, { row }) {
                    return <div>
                    {row.updatedAt}
                    </div>
                }
            },
            {
                title: this.$t('global.log.operator',{defaultValue:'操作人'}),
                key: 'updatedName',
                render(h, { row }) {
                    return <div>{row.updatedName}</div>
                }
            }, {
                title: this.$t('erp.distribution.operation',{defaultValue:'操作记录'}),
                key: 'opAction',
                render(h, { row }) {
                    return <div>{row.opAction}</div>
                }
            }, {
                title: this.$t('global.log.operalog',{defaultValue:'操作日志'}),
                key: 'opRemark',
                render(h, { row }) {
                    return <div>
                    {row.opRemark}
                    </div>
                }
            }, ]
        }
    },
    methods: {
        getLineName(id){
            let json = this.getNewDifferentAllProductList.filter(item=> {return item.value == id})[0] || {}
            return json.label
        },
        cancel() {
            this.$emit('on-close');
        },
        handleResponse(data = {}) {
            let total=0;
            this.formData = data;
            this.formAllot = (data.stockTemplateItems || []).map((item) => {
                let { assignPercent = 0, adjustValue = 0, safeQuantity = 0, accountFlag } = item;
                total+=assignPercent;
                return { assignPercent, adjustValue, safeQuantity, accountFlag }
            });
             this.formAllot.push({
                 accountFlag:this.$t('erp.b2c.product_totalcount',{defaultValue:'合计'}),
                 assignPercent:total,
             })
            
        },
       
        async getDetail() {
            this.loading = true;
            HttpSaTemplate({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
            this.getLogdetail()
        },
        getLogdetail(data = {}){
            this.tableloading = true
            this.LogformData = Object.assign({}, this.LogformData, data);
            HttpSysOpLog(this.LogformData).then(res=>{
                this.formList = res.data.content
                this.total = res.data.totalElements || 0;
                this.tableloading = false
            },err=>{
                this.errorMessage(err.message);
            })
        }
    }
}
</script>
